// extracted by mini-css-extract-plugin
module.exports = {"table":"list_table_3DZJC"};